export default __webpack_public_path__ + "static/media/usdt.23c26257.svg";